var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ab-tabs"},[_c('div',{ref:"abTabsRef",staticClass:"ab-tabs__list"},_vm._l((_vm.tabs),function(tab,i){return _c('button',{key:i,staticClass:"ab-tabs__list-item",class:{
        'ab-tabs__list-item--active': _setup.activeTabIndex === i,
      },attrs:{"type":"button"},on:{"click":function($event){return _setup.changeTab(i)}}},[_c('span',[_vm._v(_vm._s(tab))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }